(function () {
  'use strict';

  var TRIGGER_HANDLES = [
    'flair-equine-nasal-strips-classics',
    'flair-equine-nasal-strips-designs'
  ];

  var UPSELL_HANDLE = 'flair-prep-pack';

  var triggerVariantIds = [];
  var upsellVariantId = null;
  var upsellProduct = null;

  var initialized = false;
  var updating = false;
  var updateTimer = null;

  function getProduct(handle) {
    return fetch('/products/' + handle + '.js', {
      headers: {
        Accept: 'application/json'
      }
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Unable to load product: ' + handle);
      }

      return response.json();
    });
  }

  function getCart() {
    return fetch('/cart.js', {
      headers: {
        Accept: 'application/json'
      }
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Unable to load cart');
      }

      return response.json();
    });
  }

  function formatMoney(cents) {
    var amount = Number(cents) / 100;

    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(amount);
  }

  function loadProductData() {
    var triggerRequests =
      TRIGGER_HANDLES.map(function (handle) {
        return getProduct(handle);
      });

    return Promise.all([
      Promise.all(triggerRequests),
      getProduct(UPSELL_HANDLE)
    ]).then(function (results) {
      var triggerProducts = results[0];
      upsellProduct = results[1];

      triggerVariantIds = [];

      triggerProducts.forEach(function (triggerProduct) {
        var sixPackIds =
          triggerProduct.variants
            .filter(function (variant) {
              var optionText = [
                variant.title,
                variant.option1,
                variant.option2,
                variant.option3
              ]
                .filter(Boolean)
                .join(' ')
                .toLowerCase();

              return (
                optionText.indexOf('6-pack') !== -1 ||
                optionText.indexOf('6 pack') !== -1
              );
            })
            .map(function (variant) {
              return Number(variant.id);
            });

        triggerVariantIds =
          triggerVariantIds.concat(sixPackIds);
      });

      var variant =
        upsellProduct.variants.find(function (item) {
          return item.available;
        }) || upsellProduct.variants[0];

      if (!variant) {
        throw new Error(
          'No available Prep Pack variant found.'
        );
      }

      upsellVariantId = Number(variant.id);

      initialized = true;

      console.log(
        'FLAIR drawer upsell ready.',
        '6-Pack variants:',
        triggerVariantIds,
        'Prep Pack:',
        upsellVariantId
      );
    });
  }

  function cartHasSixPack(cart) {
    return cart.items.some(function (item) {
      return triggerVariantIds.indexOf(
        Number(item.variant_id)
      ) !== -1;
    });
  }

  function cartHasPrepPack(cart) {
    return cart.items.some(function (item) {
      return Number(item.variant_id) ===
        Number(upsellVariantId);
    });
  }

  function getDrawer() {
    return document.querySelector(
      'cart-element[data-cart-drawer]'
    );
  }

  function createUpsellCard() {
    var existing =
      document.getElementById(
        'flairDrawerUpsell'
      );

    if (existing) {
      return existing;
    }

    var drawer = getDrawer();

    if (!drawer) {
      return null;
    }

    var cartItems =
      drawer.querySelector(
        '#cartItemsHolder'
      );

    if (!cartItems) {
      return null;
    }

    var variant =
      upsellProduct.variants.find(function (item) {
        return Number(item.id) ===
          Number(upsellVariantId);
      });

    if (!variant) {
      return null;
    }

    var imageUrl = '';

    if (
      variant.featured_image &&
      variant.featured_image.src
    ) {
      imageUrl =
        variant.featured_image.src;
    } else if (
      upsellProduct.featured_image
    ) {
      imageUrl =
        upsellProduct.featured_image;
    }

    var wrapper =
      document.createElement('div');

    wrapper.id =
      'flairDrawerUpsell';

    wrapper.className =
      'flair-drawer-upsell';

    wrapper.innerHTML =
      '<div class="flair-drawer-upsell__heading">' +
        "Don't miss out on this!" +
      '</div>' +

      '<div class="flair-drawer-upsell__product">' +

        '<div class="flair-drawer-upsell__image-wrap">' +

          '<img' +
            ' class="flair-drawer-upsell__image"' +
            ' src="' + imageUrl + '"' +
            ' alt="' +
              upsellProduct.title.replace(/"/g, '&quot;') +
            '"' +
            ' width="180"' +
            ' height="180"' +
          '>' +

        '</div>' +

        '<div class="flair-drawer-upsell__info">' +

          '<div class="flair-drawer-upsell__title">' +
            upsellProduct.title +
          '</div>' +

          '<div class="flair-drawer-upsell__price">' +
            formatMoney(variant.price) +
          '</div>' +

          '<button' +
            ' type="button"' +
            ' class="flair-drawer-upsell__button"' +
            ' data-flair-prep-add' +
          '>' +
            'Add to cart' +
          '</button>' +

        '</div>' +

      '</div>';

    cartItems.parentNode.insertBefore(
      wrapper,
      cartItems
    );

    return wrapper;
  }

  function updateUpsell() {
    if (!initialized || updating) {
      return;
    }

    updating = true;

    getCart()
      .then(function (cart) {
        updating = false;

        var card =
          createUpsellCard();

        if (!card) {
          return;
        }

        var hasSixPack =
          cartHasSixPack(cart);

        var hasPrepPack =
          cartHasPrepPack(cart);

        var shouldShow =
          hasSixPack &&
          !hasPrepPack;

        var addButton =
          card.querySelector(
            '[data-flair-prep-add]'
          );

        if (addButton && shouldShow) {
          addButton.disabled = false;
          addButton.textContent =
            'Add to cart';
        }

        card.classList.toggle(
          'is-visible',
          shouldShow
        );

        console.log(
          'FLAIR drawer upsell:',
          shouldShow
            ? 'visible'
            : 'hidden'
        );
      })
      .catch(function (error) {
        updating = false;

        console.error(
          'FLAIR drawer upsell cart check failed:',
          error
        );
      });
  }

  function scheduleUpdate(delay) {
    clearTimeout(updateTimer);

    updateTimer = setTimeout(
      updateUpsell,
      typeof delay === 'number'
        ? delay
        : 150
    );
  }

  function addPrepPack(button) {
    if (!upsellVariantId) {
      return;
    }

    button.disabled = true;
    button.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',

      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },

      body: JSON.stringify({
        items: [
          {
            id: upsellVariantId,
            quantity: 1
          }
        ]
      })
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error(
            'Unable to add Prep Pack'
          );
        }

        return response.json();
      })
      .then(function () {
        button.textContent =
          'Added ✓';

        var card =
          document.getElementById(
            'flairDrawerUpsell'
          );

        if (card) {
          card.classList.remove(
            'is-visible'
          );
        }

        document.dispatchEvent(
          new CustomEvent(
            'theme:cart:refresh',
            {
              bubbles: true
            }
          )
        );

        scheduleUpdate(600);
      })
      .catch(function (error) {
        console.error(
          'FLAIR Prep Pack add failed:',
          error
        );

        button.disabled = false;
        button.textContent =
          'Add to cart';
      });
  }

  document.addEventListener(
    'click',
    function (event) {
      var button =
        event.target.closest(
          '[data-flair-prep-add]'
        );

      if (!button) {
        return;
      }

      event.preventDefault();

      addPrepPack(button);
    }
  );

  document.addEventListener(
    'theme:cart:open',
    function () {
      scheduleUpdate(50);
    }
  );

  document.addEventListener(
    'theme:cart:loaded',
    function () {
      scheduleUpdate(50);
    }
  );

  document.addEventListener(
    'theme:cart:refresh',
    function () {
      scheduleUpdate(500);
    }
  );

  function watchDrawer() {
    var drawer = getDrawer();

    if (!drawer) {
      return;
    }

    var observer =
      new MutationObserver(function () {
        if (
          initialized &&
          drawer.querySelector(
            '#cartItemsHolder'
          ) &&
          !drawer.querySelector(
            '#flairDrawerUpsell'
          )
        ) {
          scheduleUpdate(100);
        }
      });

    observer.observe(
      drawer,
      {
        childList: true,
        subtree: true
      }
    );
  }

  function init() {
    loadProductData()
      .then(function () {
        watchDrawer();

        scheduleUpdate(100);
      })
      .catch(function (error) {
        console.error(
          'FLAIR drawer upsell initialization failed:',
          error
        );
      });
  }

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      init
    );
  } else {
    init();
  }
})();